module.exports = __webpack_public_path__ + "media/landing_page/lightning-icon-f52cd258.svg";